import { Tooltip } from "antd"
import { getImage, getThemedImage } from "../../utils/CommonUtils"
import { useState } from "react"

const SingleImage = (props) => {

    const [isError, setIsError] = useState(false)

    const getSrcImage = (imageIcon) => {

        if (imageIcon && props.hoveredRow !== undefined) {
            return getThemedImage(props.hoveredRow ? `${`light-${imageIcon}`}` : `${`dark-${imageIcon}`}`)
        } else {
            return imageIcon? getImage(imageIcon) : ""
        }
    }

    const srcImg = getSrcImage(props.imageData?.imageIcon || props.imageData?.imageName)

    return <div className={`single-img-container ${props.className}`}>
        {(srcImg && !isError) ?
            <Tooltip title={props.imageData?.help}>
                <img
                    src={srcImg}
                    alt={props.imageData?.id}
                    style={{ height: props.height || 18, width: props.width || 18 }}
                    onError={() => setIsError(true)} // Hide if error occurs
                />
            </Tooltip> : <></>}
        {props.imageData?.label || props.imageData?.defaultValue ? <span style={{ marginLeft: "0.5em" }}>{props.imageData.label || props.imageData?.defaultValue}</span> : <></>}
    </div>
}

export default SingleImage